<template>
  <div class="container-fluid mt-3">
    <h2>Resourcen Manager {{ workLabels[workarea] }}</h2>
    <b-tabs>
      <b-tab title="Styles">
        <div class="btn-toolbar mt-3 d-flex justify-content-between">
          <button @click="newStyle" class="btn btn-primary">Neu</button>
          <div class="input-group">
            <input v-model="stylefile" type="text" class="form-control" placeholder="mystyle.css"/>
            <div class="input-group-append">
              <button @click="saveStyle" class="btn btn-primary">Speichern</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm" style="max-width:400px;">
            <strong>Dateien</strong>
            <ul class="list-group border">
              <li class="list-group-item d-flex justify-content-between" v-for="(s,index) in styles" :key="index">
                <span>{{ s }}</span>
                <div class="btn-group">
                  <button @click="openStyle(s)" class="btn-primary"><font-awesome-icon icon="edit"/></button>
                  <button @click="deleteStyle(s)" class="btn-danger"><font-awesome-icon icon="trash"/></button>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md">
            <div class="container-fluid mt-3" style="height:600px;">
              <AceEditor ref="cssEditor" editorId="cssEditor" lang="css" :content="current.content"/>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="JavaScript">
        <div class="btn-toolbar mt-3 d-flex justify-content-between">
          <button @click="newScript" class="btn btn-primary">Neu</button>
          <div class="input-group">
            <input type="text" v-model="jsfile" class="form-control"/>
            <div class="input-group-append">
              <button @click="saveScript" class="btn btn-primary">Speichern</button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm" style="max-width: 400px;">
            <strong>Dateienasdf</strong>
            <ul class="list-group border">
              <li class="list-group-item d-flex justify-content-between" v-for="(s,index) in jscripts" :key="index">
                <span>{{ s }}</span>
                <div class="btn-group">
                  <button @click="openScript(s)" class="btn-primary"><font-awesome-icon icon="edit"/></button>
                  <button @click="deleteScript(s)" class="btn-danger"><font-awesome-icon icon="trash"/></button>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-md">
            <div class="container-fluid mt-3" style="height:600px;">
              <AceEditor ref="jsEditor" editorId="jsEditor" lang="javascript" :content="current.content"/>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import AceEditor from '@/components/AceEditor.vue'
import cmsdocs from '@/modules/cmsdocs.js'

export default {
  name: 'CMSResourceManager',
  components: {
    AceEditor
  },
  data() {
    return {
      workarea: 'ihand-ui',
      current: {
        content: '',
      },
      stylefile: '',
      jsfile: '',
      styles: [],
      jscripts: [],
      workLabels: {
        'ihand-ui':'iHand Home',
        'firm-ui':'Firma',
        'firmuser-ui':'Firmen Mitarbeiter',
        'ihanduser-ui':'iHand Vertreter',
        'ihandcustomer-ui':'iHand Kunden'
      },
    }
  },
  mounted() {
    console.log('res',this.$route);
    if (this.$route.params.area) {
      this.workarea = this.$route.params.area;
      console.log('workarea update: ',this.workarea);
    }
    this.fetchData();
  },
  methods: {
    //
    // new script file
    //
    newScript() {
      this.jsfile = '';
      this.$refs.jsEditor.setContent('');
    },

    //
    // new style file
    //
    newStyle() {
      this.stylefile = '';
      this.$refs.cssEditor.setContent('');
    },

    //
    // aktuelle datei liste Laden
    //
    async fetchData() {
      console.log('pres',this,this.workarea);
      this.styles = await cmsdocs.listResources(this.workarea,'ui-styles');
      this.jscripts = await cmsdocs.listResources(this.workarea,'ui-js');
      console.log('done');
    },

    //
    // delete a given script file
    //
    deleteScript(name) {
      var self = this;
      if (!confirm('Möchten Sie die Datei "' + name + '" wirklich löschen?')) {
        return;
      }
      cmsdocs.deleteResource(this.workarea,'ui-js',name).then(function() {
        self.$bvToast.toast(name + ' wurde gelöscht.',{variant: "success", title:'Resource löschen'});
        self.fetchData();
      });
    },

    //
    // delete a given stylefile
    //
    deleteStyle(name) {
      var self = this;
      if (!confirm('Möchten Sie die Datei "' + name + '" wirklich löschen?')) {
        return;
      }
      cmsdocs.deleteResource(this.workarea,'ui-styles',name).then(function() {
        self.$bvToast.toast(name + ' wurde gelöscht.',{variant: "success", title:'Resource löschen'});
        self.fetchData();
      });
    },

    //
    // opens a script file to edit
    //
    openScript(name) {
      var self = this;
      cmsdocs.getResource(this.workarea,'ui-js',name).then(function(data) {
        self.jsfile = name;
        self.$refs.jsEditor.setContent(data);
      }).catch(function(err) {
        console.error(err);
        self.$bvToast.toast('Fehler beim Laden:' + err,{variant: "danger", title:'Resource laden'});
      })
    },

    //
    // opens a style file to edit
    //
    openStyle(name) {
      var self = this;
      cmsdocs.getResource(this.workarea,'ui-styles',name).then(function(data) {
        self.stylefile = name;
        self.$refs.cssEditor.setContent(data);
      }).catch(function(err) {
        console.error(err);
        self.$bvToast.toast('Fehler beim Ladne:' + err,{variant: "danger", title:'Resource laden'});
      })
    },

    //
    // save or update the current script file
    //
    saveScript() {
      if (!this.jsfile || !this.jsfile.endsWith('.js')) {
        this.$bvToast.toast('Ungültier Dateiname (Beispiel: myscripts.js)',{variant: 'danger',title:'Style sichern'});
        return;
      }
      var content = this.$refs.jsEditor.getContent();
      if (!content || content === '') {
        this.$bvToast.toast('Datei darf nicht leer sein',{variant: 'danger',title:'Script sichern'});
        return;
      }
      var self = this;
      cmsdocs.uploadResource(this.workarea,'ui-js',this.jsfile,content).then(function(data) {
        self.fetchData();
        self.$bvToast.toast(this.jsfile + ' wurde gespeichert.',{variant: "success", title:'Resource'});
      }).catch(function(err) {
        console.error(err);
      });
    },

    //
    // save or update the current style file
    //
    saveStyle() {
      if (!this.stylefile || !this.stylefile.endsWith('.css')) {
        this.$bvToast.toast('Ungültier Dateiname (Beispiel: mystyles.css)',{variant: 'danger',title:'Style sichern'});
        return;
      }
      var content = this.$refs.cssEditor.getContent();
      if (!content || content === '') {
        this.$bvToast.toast('Datei darf nicht leer sein',{variant: 'danger',title:'Style sichern'});
        return;
      }
      var self = this;
      cmsdocs.uploadResource(this.workarea,'ui-styles',this.stylefile,content).then(function(data) {
        self.fetchData();
        self.$bvToast.toast(self.stylefile + ' wurde gespeichert.',{variant: "success", title:'Resource'});
      }).catch(function(err) {
        console.error(err);
      });
    },

  }
}
</script>
